<div class="otiMainWrapper">
  <div class="otiWrapper">
    <div class="topSection xs-pl-10 xs-pr-10 lg-pl-0 lg-pr-0">
      <div class="alignTopSec">
        <div class="row">
          <div class="col-md-12 padding-r0">
            <div class="row addressRow">
              <div class="col-md-3 padding-l0 col-12">
                <div class="row topMargin">
                  <div class="col-sm-8 col-7 text-title-mob">ORDER #:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue font-size-mob">
                    <span>{{salesOrderNumber}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8 col-7 text-title-mob">ORDER DATE:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue">
                    <span>{{headerDetails.orderDate | date:'MM/dd/yyyy'}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8 col-7 text-title-mob">CUSTOMER PO#:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue">
                    <span>{{headerDetails.custPONumber}}</span>
                  </div>
                </div>
                <div class="row topMargin">
                  <div class="col-sm-8 col-7 text-title-mob">REQUESTED DELIVERY DATE:</div>
                  <div class="summaryValue font-size-mob col-5 col-sm-4">
                    <span>{{headerDetails.requestedDeliveryDate | date:'MM/dd/yyyy'}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8 col-7 text-title-mob">ORDER STATUS:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue">
                    <span>{{headerDetails.orderStatus}}</span>
                  </div>
                </div>
                <div class="row" *ngIf="!headerDetails.isOrderTakenByEmployee">
                  <div class="col-sm-8 col-7 text-title-mob">PLACED BY:</div>
                  <div class="col-sm-4 font-size-mob col-5 summaryValue">
                    <span>{{headerDetails.placedBy}}&nbsp;</span>
                  </div>
                </div>
              </div>
              <!--  <div class=" padding-l0">
                <div class="row">
                  <div class="col-sm-8">ORDER TYPE:</div>
                  <div class="col-sm-4 summaryValue">
                    <span>{{headerDetails.orderType}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8">ORDER METHOD:</div>
                  <div class="col-sm-4 summaryValue">
                    <span>{{headerDetails.orderMethod}}</span>
                  </div>
                </div>
              </div> -->
              <!--SoldTo Address-->
              <div *ngIf="headerDetails?.soldTo_Address" class="col-md-3">
                <div class="row">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7 pad-left-45">SOLD TO: </div>
                  <div class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">

                    <p>{{headerDetails?.soldTo_Address?.soldToAccountNumber}} </p>
                    <p>{{headerDetails?.soldTo_Address?.soldToAccountName}} </p>
                    <p>{{headerDetails?.soldTo_Address?.soldToAddress1}} </p>
                    <p>{{headerDetails?.soldTo_Address?.soldToAddress2}} </p>
                    <p>{{headerDetails?.soldTo_Address?.soldToCity}} , {{headerDetails?.soldTo_Address?.soldToState}} {{headerDetails?.soldTo_Address?.soldToZipCode}} </p>
                  </div>
                </div>
              </div>

              <!--ShipTo & DeliverTo Address-->
              <div class="col-md-3">

                <!--ShipTo-->
                <div class="row">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7 pad-left-45">SHIP TO: </div>
                  <div class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">
                    <p>{{headerDetails.staAccountNumber}} </p>
                    <p>
                      {{headerDetails.staAccountName}}
                    </p>
                    <p>{{headerDetails.staAddress}} </p>
                    <p>
                      {{headerDetails.staCity}} , {{headerDetails.staState}} {{headerDetails.staZipCode}}
                    </p>
                  </div>
                </div>

                <!--DeliverTo-->
              </div>
              <div class="col-md-3" *ngIf="headerDetails?.deliverTo_Address">
                <div class="row">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7 pad-left-45">DELIVER TO: </div>
                  <div *ngIf="headerDetails.deliverTo_Address; else elseBlock" class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">
                    <p>{{headerDetails?.deliverTo_Address?.deliverToAccountNumber}} </p>
                    <p>
                      {{headerDetails?.deliverTo_Address?.deliverToAccountName}}
                    </p>
                    <p>{{headerDetails?.deliverTo_Address?.deliverToAddress}} </p>
                    <p>
                      {{headerDetails?.deliverTo_Address?.deliverToCity}} , {{headerDetails?.deliverTo_Address?.deliverToState}} {{headerDetails?.deliverTo_Address?.deliverToZipCode}}
                    </p>
                  </div>
                </div>
                <div class="row" *ngIf="headerDetails?.ship_From">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7">SHIP FROM: </div>
                  <div class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">
                    <p>{{headerDetails?.ship_From?.sfAccount}} </p>
                    <p>
                      {{headerDetails?.ship_From?.sfCity}} , {{headerDetails?.ship_From?.sfState}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-3" *ngIf="headerDetails?.ship_From && !headerDetails?.deliverTo_Address">
                <div class="row">
                  <div class="col-sm-8 col-md-4 padding-r0 font-size-mob col-7">SHIP FROM: </div>
                  <div class="col-sm-4 col-md-8 padding-l0 summaryValue col-5 pad-left-8">
                    <p>{{headerDetails?.ship_From?.sfAccount}} </p>
                    <p>
                      {{headerDetails?.ship_From?.sfCity}} , {{headerDetails?.ship_From?.sfState}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row margin-t10">
          <div class="col-md-4 padding-l0 col-12 mob-center-text">
            <div class="product-tools-outer">
              <div class="product-tools-tab">
                <div class="text-right tab-bar">
                  <ul>
                    <li (click)="generatePdf()" class="font-size-viewReport">
                      <span class="circular-icon"><i class="far fa-file-pdf"></i></span>
                      View PDF to Print
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomSection xs-pl-10 xs-pr-10 lg-pl-0 lg-pr-0">
      <div class="row">
        <div class="col-md-12 productTableOuter productMargin padding-0">
          <div *ngFor="let item of orderSplitDetails">
            <div class="row  margin-t10 margin-b10 tableHeaderInfo">
              <div class="col-md-3 col-10 pad-left-45">
                <div class="row">
                  <div class="col-md-3 col-sm-3 col-4 padding-r0"><span class="topPadHead">Status Tracker:</span></div>
                  <div class="col-md-9 col-sm-9 col-8 padding-l0 padding-r0">
                    <div class="status-dropdown" (click)="toggleArrow(item)">
                      <span>
                        {{item.orderStatus}}
                      </span>
                      <span class="arrow-icon">
                        <i class="fas" [ngClass]="item.chevronFlag ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-12 pad-left-45 mob-center-text">
                <span class="topPadHead padding-l20">Terms: {{item.paymentTerm}}</span>
              </div>
              <div class="col-md-2 col-12 pad-left-45 mob-center-text">
                <span class="topPadHead" *ngIf="item.invoiceNumber != 0">Invoice #: {{item.invoiceNumber}}</span>
              </div>
              <!--<div class="col-md-2 col-12 pad-left-45 mob-center-text">
                <a class="nav-link" href="{{item.invoiceURL}}" target="_blank" *ngIf="item.invoiceNumber != 0">Invoice #: {{item.invoiceNumber}}</a>
              </div>-->
              <div class="col-md-2 text-right col-12 pad-left-45 mob-center-text">
                <span class="topPadHead" *ngIf="item.invoiceDate != null">Invoice Date: {{item.invoiceDate | date:'MM/dd/yyyy'}}</span>
              </div>
              <div class="col-md-2 col-10 pad-left-45 mob-center-text">
                <!--<span class="topPadHead" *ngIf="item.bolId != 0">BOL#: {{(item.bolId == '-' ? '' : item.bolId)}}</span>-->
              </div>
            </div>
            <div class="otiTableArea">
              <div *ngIf="(item.bolId && item.bolId!='' && item.bolId!='0') || item.shipDate || item.proNumber || (item.carrierName && item.carrierName!='') || (item.scac && item.scac.trim()!='')"
                   class="top-heading position-relative row m-0">
                <div class="col-12 col-md-2 padding-r0"><img src="../../../../assets/icon/svg/shipping-details.svg" class="shipping-icon"> <span class="text-left pl-2 d-inline-block"> Shipment Details </span></div>
                <div class="col-12 col-md-10">
                  <div class="row gridAlignment">
                    <div *ngIf="item.shipmentTrackingForKitesURL != '' && item.shipmentTrackingForKitesURL != null" class="spacingBetween text-left text-md-center">
                      <u><a class="shipmentTrackingLink" (click)="openShipmentTrackingURL(item.shipmentTrackingForKitesURL)">Shipment Tracking Available</a></u>
                    </div>
                    <div *ngIf="item.shipmentTrackingForKitesURL == '' || item.shipmentTrackingForKitesURL == null" class="spacingBetween text-left text-md-center">
                      Shipment Tracking Not Available
                    </div>
                    <div class="lessSpacing">
                      BOL# {{item.bolId}}
                    </div>
                    <div class="spacingBetween">
                      ETA: {{item.deliveryETA | date:'MM/dd/yyyy'}}
                    </div>
                    <div class="spacingBetween">
                      Ship Date: <span>{{item.shipDate | date:'MM/dd/yyyy'}}</span>
                    </div>
                    <div class="lessSpacing">
                      PRO: {{item.proNumber}}
                    </div>
                    <div class="spacingBetween">
                      Carrier: {{item.carrierName}}
                    </div>
                    <div class="lessSpacing">
                      SCAC: {{item.scac}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="otiTimeline" [ngClass]="item.chevronFlag ? 'hide' : ''">
                <ul class="xs-hide">
                  <li *ngFor="let lst of item.otiStatusList" [ngClass]="{currentState : lst.sequenceNo == item.sequenceNo , completedState : lst.sequenceNo < item.sequenceNo}">
                    {{lst.chevronStatus}}
                  </li>
                </ul>
              </div>
              <div class="otiTimeline-mob  d-md-none" [ngClass]="item.chevronFlag ? 'hide' : ''">
                <ul>
                  <li *ngFor="let lst of MobileStatusList" [ngClass]="{currentState : lst.sequenceNo == item.sequenceNo , completedState : lst.sequenceNo < item.sequenceNo}">
                    {{lst.chevronStatus}}
                  </li>
                </ul>
              </div>
              <div class="abcd">
                <div class="tableContainer otiSummaryTable botMargin">
                  <app-oti-grid-view [gridData]="item"></app-oti-grid-view>
                </div>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>

        <div class="otiPageFooter">
          <div class="row">
            <div class="col-md-12">
              <button *ngIf="!isBackToCppOrderSummaryRequired" mat-raised-button class="btns xs-button xs-full-width" (click)="backToOTILandingPage()">Back To View Orders</button>
              <button *ngIf="isBackToCppOrderSummaryRequired && (!isBackToSroOrderSummaryRequired)" mat-raised-button class="btns xs-button xs-full-width" (click)="backToCPPSummaryPage()">Back To CPP Orders</button>
              <button *ngIf="isBackToSroOrderSummaryRequired" mat-raised-button class="btns xs-button xs-full-width" (click)="backToCPPSummaryPage()">Back To SRA Orders</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
